import type { ReactNode } from 'react';

import type { TSubscriberGateElement } from '@shared/dream-components';
import { SubscriberGateElement } from '@shared/dream-components';

import { usePostPageScrollActions } from '~/hooks/usePostPageScrollActions';

interface Props {
  node: TSubscriberGateElement;
  children: ReactNode | ReactNode[];
}

const SubscriberGate = ({ node, children }: Props) => {
  const { isGateOpen } = usePostPageScrollActions({
    showAfterPercentageScrolled: node.attrs?.showAfterPercentageScrolled,
  });

  return (
    <SubscriberGateElement element={node} isLive isOpen={isGateOpen}>
      {children}
    </SubscriberGateElement>
  );
};

export default SubscriberGate;
